// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2qg_s","actionsCol":"EnrolledClinics_actionsCol__3yDHU"};